<template>
  <div>
    <div class="toolbar-between">
      <div class="toolbar-left">
        <!-- 添加达人 -->
        <add-master :isSet="isSet"></add-master>
        <!-- 批量设置结佣比例 -->
        <set-commission-rate isBatch :ids="table.selectRowsIds" @refresh="freshTable"></set-commission-rate>
        <!-- 批量设置销售溢价 -->
        <set-sales-premium isBatch :ids="table.selectRowsIds" @refresh="freshTable"></set-sales-premium>
        <!-- 设置我的联系方式 -->
        <contact-info @getIsSetFun="getIsSetFun"></contact-info>
      </div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item prop="fansIdOrName">
          <el-input :maxlength="255" v-model="searchForm.fansIdOrName" placeholder="达人昵称/达人ID" />
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table header-row-class-name="header" border highlight-current-row :data="table.dataSource"
      v-loading="table.loading" @selection-change="onSelectionChange">
      <el-table-column type="selection" min-width="80" align="center">
      </el-table-column>
      <el-table-column min-width="250" label="账号信息" prop="itemCreateTimeStr">
        <template slot-scope="{ row }">
          <div class="table-user">
            <img :src="row.headImage
              ? row.headImage
              : require('../../../../assets/img/default_img.png')
              " />
            <div class="table-user__right">
              <div>{{ row.userName }}</div>
              <div>达人ID：{{ row.reference }}</div>
              <div>绑定时间：{{ row.createTimeStr }}</div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="结佣比例" min-width="180">
        <template slot-scope="{ row }">
          <settle-record :row="row" />
        </template>
      </el-table-column>

      <el-table-column label="销售溢价" min-width="180">
        <template slot-scope="{ row }">
          <commission-record :row="row" />
        </template>
      </el-table-column>
      <!-- <el-table-column label="收款账户" width="200" prop="account">
          <template slot-scope="{ row }">
            <div :style="{ color: row.account ? '#333333' : '#999999' }">
              <template v-if="row.accountName">
                <div>姓名：{{ row.accountName }}</div>
                <div>银行卡号：{{ row.accountStr }}</div>
              </template>
              <template v-else>未设置</template>
            </div>
          </template>
        </el-table-column> -->
      <el-table-column label="待结佣金额(元)" min-width="120" prop="waitSettle">
      </el-table-column>
      <el-table-column label="已结佣金额(元)" min-width="120" prop="settled">
      </el-table-column>
      <el-table-column label="操作" min-width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <!-- 设置佣金比例 -->
          <set-commission-rate :row="row" :ids="[row.id]" @refresh="freshTable"></set-commission-rate>
          <!-- 设置收款账户 -->
          <!-- <set-collection-account :row="row" @refresh="freshTable"></set-collection-account> -->
          <!-- 设置销售溢价 -->
          <set-sales-premium :row="row" :ids="[row.id]" @refresh="freshTable"></set-sales-premium>
          <!-- 取消绑定 -->
          <cancel-bind :row="row" @refresh="freshTable"></cancel-bind>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total">
    </el-pagination>
  </div>
</template>

<script>
import douYin from "@/javaApi/douyin";

const DouYinModel = new douYin();

// import setCollectionAccount from "./SetCollectionAccount";
import setCommissionRate from "./SetCommissionRate";
import setSalesPremium from "./SetSalesPremium";
import addMaster from "./AddMaster";
import settleRecord from "./SettleRecord";
import commissionRecord from "./CommissionRecord";
import cancelBind from "./CancelBind";
import contactInfo from "./ContactInfo"
export default {
  props: {
    activeName: {
      // 激活名称
      type: String,
    },
  },
  components: {
    addMaster,
    // setCollectionAccount,
    setCommissionRate,
    setSalesPremium,
    settleRecord,
    commissionRecord,
    cancelBind,
    contactInfo
  },
  data() {
    return {
      searchForm: {
        // 搜素表单
        fansIdOrName: "", // 粉丝ID或者名称
      },
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        selectRowsIds: [], // 选中数据
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      isSet:0,
    };
  },
  watch: {
    activeName: {
      immediate: true,
      handler: async function () {
        if (this.activeName === "first") {
          this.freshTable();
        }
      },
    },
  },
  methods: {
    getIsSetFun(e) {
      this.isSet = e
      console.log(this.isSet,'getIsSetFun==是否设置了联系方式')
    },
    // 表格批量操作
    onSelectionChange(arr) {
      this.table.selectRowsIds = arr.map((item) => item.id);
    },
    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 表单重置`
    onFormReset() {
      this.table.selectRowsIds = [];
      this.searchForm.fansIdOrName = "";
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      let datas = {
        ...this.pagination,
        ...this.searchForm, 
      }
      console.log(datas,'datas请求表格')
      const data = await DouYinModel.getMasterPageKs({
        ...this.pagination,
        ...this.searchForm,
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/distribution/MyMaster.vue